
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyCanDanger as ObiBuoyCanDangerElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-can-danger.js';
 
 
 

 
 export const ObiBuoyCanDanger = createComponent({
   react: React,
   tagName: 'obi-buoy-can-danger',
   elementClass: ObiBuoyCanDangerElement,
   events: {
     
   }
  });
 
 